import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'nk-card-footer',
  imports: [],
  templateUrl: './card-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardFooterComponent {
  @Input() public transparent = true;
  @Input() public andClass = '';
}
